import {
  RmaLrpCommodityCodes,
  RmaLrpCommodityNames,
  RmaLrpTypeCodeNames,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { z, zCalendarDate, zDecimalRequired } from '@harvestiq/zod';

export const getCommodityOptionsV2QuerySchema = z.object({
  salesEffectiveDate: zCalendarDate().openapi({
    example: '2025-06-13',
  }),
});

export type GetCommodityOptionsV2Query = z.infer<
  typeof getCommodityOptionsV2QuerySchema
>;

export const getCommodityOptionsV2ResponseSchema = z.object({
  commodityOptions: z
    .object({
      commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
      commodityName: z.nativeEnum(RmaLrpCommodityNames),
      typeCode: z.nativeEnum(RmaLrpTypeCodes),
      typeName: z.nativeEnum(RmaLrpTypeCodeNames),
      salesEffectiveDate: zCalendarDate(),
      endDate: zCalendarDate(),
      endorsementLengthCount: z.number().int(),
      reinsuranceYear: z.number().int(),
      targetLowWeight: zDecimalRequired(),
      targetHighWeight: zDecimalRequired(),
    })
    .array()
    .openapi({
      externalDocs: {
        description:
          'Commodity Codes and Type Codes are provided by the RMA docs and can vary by year.',
        url: 'https://pubfs-rma.fpac.usda.gov/pub/References/actuarial_data_master/2026/index.html',
      },
      example: [
        {
          commodityCode: RmaLrpCommodityCodes.FEEDER_CATTLE,
          commodityName: RmaLrpCommodityNames.FEEDER_CATTLE,
          typeCode: RmaLrpTypeCodes.STEERS_WEIGHT_1,
          typeName: 'Steers Weight 1',
          salesEffectiveDate: '2025-06-13',
          endDate: '2025-09-12',
          endorsementLengthCount: 13,
          reinsuranceYear: 2025,
          targetLowWeight: '1',
          targetHighWeight: '5.99',
        },
      ],
    }),
});
export type GetCommodityOptionsV2Response = z.infer<
  typeof getCommodityOptionsV2ResponseSchema
>;
